// German translations for product labels from the API
const labelMap = {
  'Sale': 'Angebot',
  'New': 'Neu',
  'BestSelling': 'Bestseller',
  'Best Selling': 'Bestseller',
  'Featured': 'Empfohlen',
  'Hot': 'Beliebt',
  'Service': 'Dienstleistung',
};

export const translateLabel = (label) => {
  if (!label) return '';
  return labelMap[label] || label;
};

export default translateLabel;
